import { Mail, FileText, CalendarDays, Clock } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

export const AdminStats = ({ contacts, intakes, appointments = [] }) => {
  const pendingCount = contacts.filter(c => c.status === 'new').length
    + intakes.filter(i => i.status === 'new').length
    + appointments.filter(a => a.status === 'pending').length;
  const upcomingCount = appointments.filter(a => ['pending', 'confirmed'].includes(a.status)).length;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
      <StatCard icon={Mail} iconBg="bg-blue-100" iconColor="text-blue-600" value={contacts.length} label="Contact Messages" />
      <StatCard icon={FileText} iconBg="bg-green-100" iconColor="text-green-600" value={intakes.length} label="Intake Forms" />
      <StatCard icon={CalendarDays} iconBg="bg-orange-100" iconColor="text-primaryOrange" value={upcomingCount} label="Upcoming Appointments" />
      <StatCard icon={Clock} iconBg="bg-yellow-100" iconColor="text-yellow-600" value={pendingCount} label="Pending Review" />
    </div>
  );
};

const StatCard = ({ icon: Icon, iconBg, iconColor, value, label }) => (
  <Card className="border-none shadow-md">
    <CardContent className="p-4 flex items-center gap-3">
      <div className={`w-10 h-10 ${iconBg} rounded-full flex items-center justify-center`}>
        <Icon className={iconColor} size={20} />
      </div>
      <div>
        <p className="text-2xl font-bold text-darkBrown">{value}</p>
        <p className="text-xs text-gray-500">{label}</p>
      </div>
    </CardContent>
  </Card>
);
